module.exports = __webpack_public_path__ + "static/media/Satisfaction_illustration.087b01bb.png";